import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
    body{
        width:100vw;
        height:100vh;
    }

`;

export default GlobalStyles;
